var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBtcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6995 12.419C18.364 17.7762 12.938 21.0365 7.58017 19.7006C2.22459 18.365 -1.0357 12.9387 0.300462 7.58197C1.63545 2.22419 7.06142 -1.03634 12.4176 0.299234C17.775 1.63481 21.0351 7.0617 19.6994 12.4191L19.6995 12.419H19.6995Z",
    fill: "#F7931A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4094 8.57447C14.6084 7.24369 13.5952 6.52834 12.2098 6.05114L12.6592 4.24848L11.5619 3.97505L11.1244 5.73024C10.8359 5.65829 10.5397 5.5905 10.2452 5.52329L10.6859 3.75651L9.58925 3.48308L9.13956 5.28515C8.90084 5.2308 8.66636 5.17708 8.43888 5.12048L8.44015 5.11481L6.9269 4.73692L6.635 5.90895C6.635 5.90895 7.44913 6.09557 7.43197 6.10705C7.87633 6.21796 7.95669 6.51211 7.94334 6.74527L7.43139 8.79892C7.46198 8.80669 7.50167 8.81794 7.54547 8.83553C7.50886 8.82644 7.4699 8.81652 7.42948 8.80684L6.71188 11.6837C6.65758 11.8187 6.51974 12.0213 6.20907 11.9444C6.22006 11.9603 5.41151 11.7454 5.41151 11.7454L4.8667 13.0014L6.2947 13.3574C6.56036 13.4241 6.82069 13.4938 7.07706 13.5593L6.62297 15.3826L7.71904 15.6561L8.16873 13.8521C8.46816 13.9334 8.75875 14.0084 9.04322 14.079L8.59505 15.8745L9.69243 16.1479L10.1465 14.328C12.0177 14.6822 13.4246 14.5394 14.0169 12.8469C14.4941 11.4842 13.9931 10.6983 13.0087 10.1857C13.7257 10.0204 14.2658 9.54878 14.4098 8.57462L14.4094 8.57437L14.4094 8.57447ZM11.9022 12.0901C11.5631 13.4528 9.2688 12.7162 8.52496 12.5315L9.12754 10.1159C9.87133 10.3016 12.2566 10.669 11.9023 12.0901H11.9022ZM12.2416 8.55472C11.9322 9.7942 10.0227 9.16449 9.40322 9.01008L9.94954 6.81927C10.569 6.97368 12.5638 7.26187 12.2417 8.55472H12.2416Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcLogo);
export default __webpack_public_path__ + "static/media/btcLogo.4e21365731fd226b88fac39ef8af2a91.svg";
export { ForwardRef as ReactComponent };